export default "__VITE_ASSET__Dx6SreyM__"